import { createSlice } from "@reduxjs/toolkit";
import moment from "moment-timezone";

const DateSlice = createSlice({
    name: "date",
    initialState: {
        date: moment(new Date()).utc().add(1, 'day').format(),
        isFirstTime: true,
    },
    reducers: {
        addDate(state, action) {
            // Reassigning `state` is a no-op in Immer, so always mutate fields
            state.date = action.payload;
            state.isFirstTime = false;
        },
        clearDate(state) {
            state.date = moment(new Date()).utc().add(1, 'day').format();
            state.isFirstTime = true;
        }
    },
});

export const { addDate, clearDate } = DateSlice.actions;
export default DateSlice.reducer;
